<template>
  <div>
    <form id="search-form">
      <div>
        <textarea
          ref="inputArea"
          type="text"
          name="q"
          class="inputarea card-animate-2"
          placeholder="Describe your query here"
          v-model="queryPrompt"
          rows="4"
          cols="500"
          @keyup.enter="submitQuery"
          @input="submitQuery"
        ></textarea>
      </div>

      <br />
      <div>
        <v-btn class="mx-2" @click.prevent="submitQuery">Submit</v-btn>
        <v-btn class="mx-2" type="button" @click="resetDialogue">Reset</v-btn>
      </div>
    </form>

    <div id="dialogueResults">
      <p v-for="(entry, index) in dialogueHistory" :key="index" v-html="entry"></p>
    </div>
    <br />
    <div v-if="loading" class="loading-container">
      <img class="mx-auto d-block" style="height: 25%; width: 25%" src="../assets/images/loading-spinner15.gif" alt="Loading" />
      <br />
      <p>{{ loadingText }}</p>
    </div>

    <div>
      <v-btn class="mx-2" @click="saveTable">Save Table</v-btn>
      <v-btn class="mx-2" v-if="editingTableIndex !== -1" @click="updateSavedTable">Update Saved Table</v-btn>
    </div>
    <br />
    <iframe ref="generatedTableIframe" width="100%" height="500"></iframe>
    <br />
    <saved-table-list
      :saved-tables="savedTables"
      @edit-table="editSavedTable"
      @delete-table="deleteSavedTable"
    ></saved-table-list>
    <br />
    <v-overlay :value="overlay" opacity="0.99" z-index="9">
      <GeneratedTable v-if="type == 'table'" />
    </v-overlay>
  </div>
</template>

<script>
import GeneratedTable from "./GeneratedTable.vue";
import SavedTableList from "./SavedTableList.vue";

export default {
  components: {
    SavedTableList,
    GeneratedTable,
  },
  data() {
    return {
      overlay: false,
      tableData: { headers: [], rows: [] },
      loading: false,
      loadingText: "",
      editingTableIndex: -1,
      queryPrompt: "",
      dialogueHistory: [],
      savedTables: [],
    };
  },
  mounted() {
    this.$refs.inputArea.focus();
    const storedSavedTables = JSON.parse(localStorage.getItem("savedTables"));
    if (storedSavedTables) {
      this.savedTables = storedSavedTables;
    }
    this.contentWindow = this.$refs.generatedTableIframe.contentWindow;
    this.updateIframe();
  },
  methods: {
    async submitQuery() {
      if (!this.queryPrompt) return;

      this.displayDialogue(`<strong>User:</strong> ${this.queryPrompt}`);

      this.loading = true;
      this.loadingText = "Submitted...";
      setTimeout(() => {
        this.loadingText = "Thinking...";
      }, 1000);

      try {
        const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence3`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ message: this.queryPrompt }),
        });
        const content = await response.json();
        const tableContent = content.message;
        this.loadingText = "Generating Table";
        this.updateIframe();

        const tableLines = tableContent.trim().split('\n');
        const headers = tableLines[0].split('|').map((header) => header.trim());
        const rows = tableLines.slice(1).map((row) =>
          row.split('|').map((cell) => cell.trim())
        );
        this.tableData = { headers, rows };
        this.loading = false;
        this.loadingText = "";
        
        this.queryPrompt = "";

} catch (err) {
console.error(err);
}
},
displayDialogue(entry) {
this.dialogueHistory.push(entry);
},
editSavedTable(index) {
const table = this.savedTables[index];
this.tableData = table;
this.editingTableIndex = index;
},
updateSavedTable() {
const updatedTable = this.tableData;
this.savedTables[this.editingTableIndex] = updatedTable;
localStorage.setItem("savedTables", JSON.stringify(this.savedTables));
alert("Table updated!");
this.editingTableIndex = -1;
},
deleteSavedTable(index) {
this.savedTables.splice(index, 1);
localStorage.setItem("savedTables", JSON.stringify(this.savedTables));
},
saveTable() {
const table = this.tableData;
const date = new Date().toISOString();
this.savedTables.push({ date, table });
localStorage.setItem("savedTables", JSON.stringify(this.savedTables));
alert("Table saved!");
},
updateIframe() {
  const doc = this.$refs.generatedTableIframe.contentDocument;
  const iframeNode = this.$refs.generatedTableIframe;
  doc.open();
  doc.write(
    `<html>
      <head>
        <style>
          .table {
            border-collapse: collapse;
            width: 100%;
          }
          .table th {
            background-color: #f2f2f2;
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
          }
          .table td {
            border: 1px solid #ddd;
            padding: 8px;
          }
        </style>
      </head>
      <body>
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                ${this.tableData.headers.map((header) => `<th>${header}</th>`).join("")}
              </tr>
            </thead>
            <tbody>
              ${this.tableData.rows
                .map(
                  (row) =>
                    `<tr>${row.map((cell) => `<td>${cell}</td>`).join("")}</tr>`
                )
                .join("")}
            </tbody>
          </table>
        </div>
      </body>
    </html>`
  );
  doc.close();
  iframeNode.height = doc.documentElement.scrollHeight + 20;
}


  },
  watch: {
    tableData: {
      deep: true,
      handler() {
        this.updateIframe();
      },
    },
  },
};
</script>


<style>
.ace_cursor {
  border-right: 0.15em solid orange;
  animation: blink-caret 0.5s step-end infinite;
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from,
  to {
    border-color: transparent;
  }
  50% {
    border-color: orange;
  }
}
.ace_line {
  white-space: nowrap;
  margin: 0 auto;
  letter-spacing: 0.15em;
  animation: typing 0.0001s steps(30, end);
}

/* The typing effect */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 5px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 900px) {
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
}
.inputarea {
  width: 100%;
  height: 100%;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 16px;
  resize: none;
}

#codeEditor {
    width: 100%;
    height: 400px;
}
  #outputIframe {
    width: 100%;
    height: 400px;
    border: 1px solid #ccc;
  }
  
  #dialogueResults {
    padding: 10px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
    max-height: 200px;
    overflow-y: auto;
  }
  #savedProjects {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  max-height: 200px;
  overflow-y: auto;
}
</style>


